import React, { useEffect, useState } from "react";
import DynamicNav from "../components/DynamicNav/DynamicNav";
import SideNav from "../containers/SideNav/SideNav";
import { useNavigate } from "react-router-dom";

const DashboardLayout = ({ children, title }) => {
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const isLoggedIn = localStorage.getItem('authToken'); // Check for authToken

  const history = useNavigate();

  const toggleSideNav = () => {
    setIsSideNavOpen(!isSideNavOpen);
  };

  useEffect(() => {
    if (isLoggedIn === "" || isLoggedIn === null) {
      history("/");
    }
  }, []);

  return (
    <div>
      <div className="margleft">
        <DynamicNav title={title} toggleSideNav={toggleSideNav} />
      </div>
      <div>
        <SideNav isOpen={isSideNavOpen} toggleSideNav={toggleSideNav} />
      </div>
      <div>{children}</div>
    </div>
  );
};

export default DashboardLayout;
